// extracted by mini-css-extract-plugin
module.exports = {"alertBody":"DevkitForm_alertBody__NMgYl","heading":"DevkitForm_heading__2Di6O"};